import { createSlice } from "@reduxjs/toolkit";

const yearAccumulateSlice = createSlice({
  name: "accountCategory",
  initialState: {
    isLoading: false,
    isLogin: false,
    yearAccumulateList: [],
    // employeeDropDown: [],
  },
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setYearAccumulateList(state, action) {
      state.yearAccumulateList = action.payload;
    },
    // setEmployeeDropDown(state, action) {
    //   state.employeeDropDown = action.payload;
    // },
  },
});

export const { setIsLoading, setYearAccumulateList: setYearAccumulateList } =
  yearAccumulateSlice.actions;
export default yearAccumulateSlice.reducer;
